export default __webpack_public_path__ + "static/media/3.cf4052be.png";